import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getProducts(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/products/500/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function getProductByCompanyId(accessToken, id) {
  const result = await axios.get(`${BASE_API_URL}/getByCompanyId/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function editProduct(accessToken, data) {
  const result = await axios(`${BASE_API_URL}/products`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}

export async function getDefaultProducts(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/productDefault/500/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function getDefaultProductById(accessToken, id) {
  const result = await axios.get(`${BASE_API_URL}/productDefault/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function createCompanyProduct(accessToken, data) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/products`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result.data;
}